var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _rect, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvaluar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_doc_check_lineal_color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.999,
    height: 62,
    viewBox: "0 0 61.999 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104969",
    "data-name": "Trazado 104969",
    d: "M52,56V7a5,5,0,0,0-5-5H7a5,5,0,0,1,5,5V55.748A6.166,6.166,0,0,0,17.815,62,6,6,0,0,0,24,56Z",
    transform: "translate(-1 -1)",
    fill: "#b1e0de"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104970",
    "data-name": "Trazado 104970",
    d: "M57,28,39,46l-5-5L52,23Z",
    transform: "translate(-1 -1)",
    fill: "#fc287e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104971",
    "data-name": "Trazado 104971",
    d: "M39,46l-5-5-4,9Z",
    transform: "translate(-1 -1)",
    fill: "#fadfb2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104972",
    "data-name": "Trazado 104972",
    d: "M35.538,47.538l-3.076-3.076L30,50Z",
    transform: "translate(-1 -1)",
    fill: "#474747"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104973",
    "data-name": "Trazado 104973",
    d: "M53.879,20.464h4.243v7.071H53.879Z",
    transform: "translate(-1.569 45.627) rotate(-45)",
    fill: "#fce3ed"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104974",
    "data-name": "Trazado 104974",
    d: "M55,20l5,5,.965-.966a3.535,3.535,0,0,0-5-5Z",
    transform: "translate(-1 -1)",
    fill: "#ee2b7c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16634",
    "data-name": "Grupo 16634",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104975",
    "data-name": "Trazado 104975",
    d: "M12,19H4a2,2,0,0,1-2-2V7A5,5,0,0,1,12,7Z",
    fill: "#1aa8a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104976",
    "data-name": "Trazado 104976",
    d: "M17.815,62A6,6,0,0,0,24,56H56a6,6,0,0,1-6,6Z",
    fill: "#1aa8a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104977",
    "data-name": "Trazado 104977",
    d: "M16,18H26V28H16Z",
    fill: "#fce3ed"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104978",
    "data-name": "Trazado 104978",
    d: "M22,26a1,1,0,0,1-.708-.292l-3-3,1.415-1.415L22,23.584l8.292-8.293,1.415,1.415-9,9A1,1,0,0,1,22,26Z",
    transform: "translate(-1 -1)",
    fill: "#6bc13b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104979",
    "data-name": "Trazado 104979",
    d: "M16,34H26V44H16Z",
    transform: "translate(-1 -1)",
    fill: "#fce3ed"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104980",
    "data-name": "Trazado 104980",
    d: "M22,42a1,1,0,0,1-.708-.292l-3-3,1.415-1.415L22,39.584l8.292-8.293,1.415,1.415-9,9A1,1,0,0,1,22,42Z",
    transform: "translate(-1 -1)",
    fill: "#6bc13b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_85498",
    "data-name": "Rect\\xE1ngulo 85498",
    width: 28,
    height: 6,
    rx: 3,
    transform: "translate(17 5)",
    fill: "#1aa8a2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104981",
    "data-name": "Trazado 104981",
    d: "M47,28H30V24H51",
    transform: "translate(-1 -1)",
    fill: "#1aa8a2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104982",
    "data-name": "Trazado 104982",
    d: "M41,51h8v2H41Z",
    transform: "translate(-1 -1)",
    fill: "#78a0d4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104984",
    "data-name": "Trazado 104984",
    d: "M61.671,24.741a4.536,4.536,0,1,0-6.415-6.414L53,20.583V7a6.007,6.007,0,0,0-6-6H7A6,6,0,0,0,1,7V17a3,3,0,0,0,3,3h7V55.748A7.184,7.184,0,0,0,17.785,63H50a7.008,7.008,0,0,0,7-7,1,1,0,0,0-1-1H53V33.413ZM32.782,46.2,33.8,47.215l-1.831.813Zm2.977.147-2.106-2.106.668-1.5,2.94,2.94ZM39,44.584,35.413,41,52,24.414,55.584,28ZM46.585,27H31V25H48.584Zm6.829-4L55,21.414,58.584,25,57,26.584Zm5.05-4a2.535,2.535,0,0,1,1.792,4.327L60,23.583,56.414,20l.257-.257A2.518,2.518,0,0,1,58.464,19ZM11,18H4a1,1,0,0,1-1-1V7a4,4,0,1,1,8,0ZM50,61H22.9a6.931,6.931,0,0,0,2.03-4H54.9A5.008,5.008,0,0,1,50,61Zm1-6H24a1,1,0,0,0-1,1,5,5,0,0,1-4.833,5h-.336A5.172,5.172,0,0,1,13,55.748V7a5.969,5.969,0,0,0-1.54-4H47a4,4,0,0,1,4,4V22.583L50.584,23H30a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H44.584L33.291,40.291a1.012,1.012,0,0,0-.206.3l-4,9A1,1,0,0,0,30,51a.978.978,0,0,0,.405-.087l9-4a1.012,1.012,0,0,0,.3-.206L51,35.412Z",
    transform: "translate(-1 -1)",
    fill: "#3b0310"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104985",
    "data-name": "Trazado 104985",
    d: "M16,29H26a1,1,0,0,0,1-1V21.414l4.707-4.708L30.29,15.291,27,18.583V18a1,1,0,0,0-1-1H16a1,1,0,0,0-1,1V28A1,1,0,0,0,16,29Zm1-10h8v1.585l-3,3-2.292-2.293-1.415,1.415,3,3a1,1,0,0,0,1.415,0L25,23.414V27H17Z",
    transform: "translate(-1 -1)",
    fill: "#3b0310"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104986",
    "data-name": "Trazado 104986",
    d: "M31.7,32.707,30.29,31.292,27,34.584V34a1,1,0,0,0-1-1H16a1,1,0,0,0-1,1V44a1,1,0,0,0,1,1H26a1,1,0,0,0,1-1V37.414ZM25,43H17V35h8v1.584l-3,3-2.292-2.293-1.415,1.415,3,3a1,1,0,0,0,1.415,0L25,39.414Z",
    transform: "translate(-1 -1)",
    fill: "#3b0310"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104987",
    "data-name": "Trazado 104987",
    d: "M21,13H43a4,4,0,0,0,0-8H21a4,4,0,0,0,0,8Zm0-6H43a2,2,0,0,1,0,4H21a2,2,0,0,1,0-4Z",
    transform: "translate(-1 -1)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104988",
    "data-name": "Trazado 104988",
    d: "M41,51h8v2H41Z",
    transform: "translate(-1 -1)",
    fill: "#3b0310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluar);
export default __webpack_public_path__ + "static/media/evaluar.f19d33abb37811d15d338829ce997cbc.svg";
export { ForwardRef as ReactComponent };